import _ from 'lodash';
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import AuthService from '../security/AuthService';

import { User } from '../ifmsTypes';

const authService = new AuthService();

interface LoginState {
  user: User|null,
};

const initialState:LoginState = { user: null };

function doChangeUserIconUrl(currentState: Draft<LoginState>, iconUrl: string) {
  if (currentState && currentState.user)
    currentState.user.userIcon = iconUrl;
}

/**
 * Slice for controlling login user data
 */
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    logoutUser: () => {
      authService.removeUser();
      return _.cloneDeep(initialState);
    },
    changeUserIconUrl: (state, action: PayloadAction<{ url: string }>) => {
      doChangeUserIconUrl(state, action.payload.url);
    },
    reset: () => {
      // From here we can take action only at this "login" state
      // But, as we have taken care of this particular "reset" action
      // in rootReducer, we can use it to CLEAR the complete Redux Store's state
    },
  }
});

export default loginSlice.reducer;

export const { loginUser, logoutUser, reset, changeUserIconUrl } = loginSlice.actions;
